module.exports = __webpack_public_path__ + "static/Groovy-22c622bf492608087b19205a2bb2d913.svg";